import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';
import { CustomerMembership } from '../../../../../../../../../../models/membership';
import { dateStringFromISO8601 } from '../../../../../../../../../../utils';

@Component({
  selector: 'app-edit-recurring-customer-membership-unfreeze',
  templateUrl: './edit-recurring-customer-membership-unfreeze.component.html',
  styleUrls: ['./edit-recurring-customer-membership-unfreeze.component.css']
})
export class EditRecurringCustomerMembershipUnfreezeComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public unfreezeEmailText = '';

  public errorMessage = '';

  public dateStringFromISO8601 = dateStringFromISO8601;

  private saveClickedSubscription: Subscription;

  constructor(
    public organizationConfigService: OrganizationConfigService,
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  private handleSave() {
    this.loadingEvent.emit(true);

    this.customerService
      .unFreezeMembership(
        this.membership,
        this.unfreezeEmailText
      )
      .then(() => {
        this.savedCallback('Membership unfrozen successfully.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to unfreeze this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
